/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PreRegistrationModel } from '../../models/pre-registration-model';

export interface PreRegistrationPost$Params {
      body?: PreRegistrationModel
}

export function preRegistrationPost(http: HttpClient, rootUrl: string, params?: PreRegistrationPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, preRegistrationPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as PracticeStrictHttpResponse<void>;
    })
  );
}

preRegistrationPost.PATH = '/PreRegistration';
